module.exports = __webpack_public_path__ + "img/healthy.a3e04e31.jpeg";